// findMeetingById — pure lookup of a meeting in the edited trip by `id`.
//
// Extracted verbatim from `EditTripModal.js` (the `editedTrip.meetings.find(...)`
// at the top of `handleDeleteMeeting`, used to resolve the meeting before the
// confirmation prompt) as part of the behavior-preserving refactor (issue #240).
// It returns the first meeting whose `id` matches, or `undefined` when none do —
// exactly as `Array.prototype.find` does at the source call site.
//
// Totality preserved exactly: the source read `editedTrip.meetings` directly
// (guaranteed an array by `initializeEditedTrip`); this lookup mirrors that with
// no added guard. The `window.confirm` gate and the subsequent state update stay
// in the hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Finds a meeting in the edited trip by its `id`.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @param {*} meetingId - The `id` of the meeting to find.
 * @returns {Object|undefined} The matching meeting, or `undefined` if not found.
 */
export function findMeetingById(editedTrip, meetingId) {
  return editedTrip.meetings.find(m => m.id === meetingId);
}

export default findMeetingById;
